module.exports = __webpack_public_path__ + "media/about/quote-prop-88d93e2a.png";